import { RouterView } from "vue-router";

export const deviceErrorsRoute = {
  path: ":menu/device-errors",
  component: <RouterView />,
  children: [
    {
      path: "",
      component: () => import("@/views/device-errors/list/index.vue"),
    },
  ],
};
